export default "__VITE_ASSET__BYP9otXW__"